import { createMiddleware } from 'redux-beacon';
import { LOCATION_CHANGE } from 'react-router-redux';
import GoogleAnalytics, {
  trackPageView,
  trackEvent,
} from '@redux-beacon/google-analytics';

import { types } from '@actions/conference';

const eventsMap = {
  [LOCATION_CHANGE]: trackPageView(({ payload: { pathname, search, hash } }) => ({
    page: `${pathname}${search}${hash}`,
  })),
  [types.DOWNLOAD.STARTED]: trackEvent(({ filename }) => ({
    category: 'TranscriptView',
    action: 'DownloadPDF',
    label: filename,
  })),
};

export default createMiddleware(eventsMap, GoogleAnalytics());



// WEBPACK FOOTER //
// ./redux/enhancers/analytics.js